import { useRouter } from 'next/router'
import React, { useState, useEffect } from 'react'
import SwiperCore, { Navigation } from 'swiper'
import Button from '../../atoms/Button/Button'
import Color from '../../atoms/Color/Color'
import {
  Car,
  Pin,
  Book,
  Download,
  EMail,
  Info,
  WishlistFill,
  WishlistLine,
  ChevronRight,
} from '../../atoms/NewIcons'
import Taglia from '../../atoms/Taglia/Taglia'
import Trans from '../../atoms/Trans/Trans'
import _ from 'lodash'
import 'react-medium-image-zoom/dist/styles.css'
import useTrans from '../../../hooks/useTrans'
import Tooltip from '../../atoms/Tooltip/Tooltip'
import ModalLogin from '../../organisms/ModalLogin/ModalLogin'
import useDownloadFromApi from '../../../hooks/useDownloadFromApi'
import {
  showButtonsRiepilogo,
  showDettagliProdotto,
  showRiepilogo,
  showTabellaSchedaProdotto,
} from '../../../utils/servicegift'
import { GIORNICONSEGNA } from '../../../utils/endpoint'
import { useSelector } from 'react-redux'
import { api } from '../../../utils'
import { trackingDownload } from '../../../utils/gtm'
import PrezziProdottoTable from '../PrezziProdottoTable/PrezziProdottoTable'
import ProdottoGallery from '../ProdottoGallery/ProdottoGallery'

SwiperCore.use([Navigation])

const MainProdotto = ({
  utente,
  prodotto,
  selectedArticolo,
  selectedTaglia,
  selectedColor,
  HandleColorClick,
  variant,
  wishlist,
  ArrowClick,
  service_gift,
  scrollToDettagli,
  scrollToTableSchedaProdotto,
  setSelectedTaglia,
  personalizzazioni,
  prezziPersonalizzazioni,
  leadTimeSelected,
}) => {
  const t = useTrans()
  const router = useRouter()
  const isAs400Down = useSelector((state) => state.servicegift.as400_down)
  const [filteredTaglie, setTaglie] = useState([])
  const [filteredColori, setColori] = useState([])
  const [selectedImage, setSelectedImage] = useState(
    selectedArticolo?.immagini[0] ? selectedArticolo.immagini[0] : null
  )

  const findTaglie = () => {
    const taglie_colori = prodotto?.colori?.filter((colore) => colore.id === selectedColor.id)[0]
    setTaglie(taglie_colori?.taglie ? taglie_colori?.taglie : [])
  }
  const checkValues = () => {
    if (prodotto?.taglie?.length > 0) {
      let new_taglie = []
      let new_colori = []
      prodotto?.taglie.forEach(
        (taglia) => !new_taglie.includes(taglia.id) && new_taglie.push(taglia.id)
      )
      prodotto?.colori.forEach(
        (colore) => !new_colori.includes(colore.id) && new_colori.push(colore.id)
      )

      new_colori.map(
        (colore) => prodotto?.colori?.filter((colore_filtered) => colore_filtered?.id === colore)[0]
      )
      findTaglie()
      setColori(
        new_colori.map(
          (colore) =>
            prodotto?.colori?.filter((colore_filtered) => colore_filtered?.id === colore)[0]
        )
      )
    }
  }

  useEffect(() => {
    setSelectedImage(selectedArticolo?.immagini[0] ? selectedArticolo.immagini[0] : null)
    findTaglie()
  }, [selectedArticolo, selectedArticolo?.prezzo])

  useEffect(() => {
    findTaglie()
  }, [selectedColor])

  useEffect(() => {
    handleChangeColor(prodotto, selectedColor, selectedArticolo, selectedTaglia)
  }, [selectedColor])

  useEffect(() => {
    selectedTaglia && HandleChangeTaglia(selectedTaglia)
  }, [selectedTaglia])
  useEffect(() => {
    checkValues()
  }, [])

  const handleChangeColor = (prodotto, colore, articolo, taglia) => {
    let slug = ''
    if (taglia != '') {
      slug = prodotto.articoli.filter(
        (item) => item.attributi_lista.filter((attributo) => attributo.id === colore.id).length > 0
      )
      if (slug.length > 0) {
        let support = slug.filter(
          (item) =>
            item.attributi_lista.filter((attributo) => attributo.id == taglia?.id).length > 0
        )
        if (support.length == 0) {
          slug = slug[0].url
        } else {
          slug = support[0].url
        }
      } else {
        slug = slug[0].url
      }
    } else {
      slug = prodotto.articoli.filter(
        (item) => item.attributi_lista.filter((attributo) => attributo.id === colore.id).length > 0
      )[0].url
    }
    router.push(slug, undefined, {
      shallow: true,
    })
    HandleColorClick(colore)
  }

  const HandleChangeTaglia = (taglia) => {
    setSelectedTaglia(taglia)
    let slug = prodotto.articoli.filter(
      (item) =>
        item.attributi_lista.filter((attributo) => attributo.id === selectedColor.id).length > 0
    )
    let taglieItem = slug.filter(
      (item) => item.attributi_lista.filter((attributo) => attributo.id == taglia.id).length > 0
    )
    taglieItem.length > 0
      ? router.push(taglieItem[0].url, undefined, {
        shallow: true,
      })
      : router.push(slug[0].url, undefined, {
        shallow: true,
      })
  }

  const [popupLogin, setPopupLogin] = useState(false)
  const certificazioni = selectedArticolo?.certificazioni?.filter((x) => !!x.image?.url) || []

  return (
    <>
      <div className="main__prodotto">
        <ProdottoGallery
          prodotto={prodotto}
          selectedArticolo={selectedArticolo}
          selectedImage={selectedImage}
          setSelectedImage={setSelectedImage}
          wishlist={wishlist}
          handleWishlist={ArrowClick}
          certificazioni={certificazioni}
        />

        <div className="prodotto">
          <div className="prodotto__header">
            <div className="prodotto__header__intro">
              <div>
                <p className="prodotto__header__nome">
                  <span className="prodotto__header__nome__codice">
                    <Trans
                      chiave={selectedArticolo?.codice ? 'Codice articolo' : 'Codice prodotto'}
                    />
                    {': '}
                    {selectedArticolo?.codice || prodotto?.codice}
                  </span>
                  {prodotto?.alternativo?.codice && (
                    <span>
                      {' ('}
                      <Trans chiave="Prodotto alternativo" />:{' '}
                      <a href={prodotto?.alternativo.url} className="prodotto__alternativo-link">
                        {prodotto?.alternativo.codice}
                      </a>
                      {')'}
                    </span>
                  )}
                </p>
                <h1 className="prodotto__header__title">
                  {prodotto?.nome ? `${prodotto.nome} - ` : ''}
                  {selectedArticolo?.titolo}
                </h1>
              </div>
            </div>

            <p className="prodotto__header__descrizione">{selectedArticolo?.descrizione}</p>
          </div>
          <div className="prodotto__buttons__wrapper">
            <Button
              label={t('Vedi disponibilità')}
              variant="ghost"
              icon={<Info />}
              icon_pos={'left'}
              onClick={() =>
                showTabellaSchedaProdotto(utente, service_gift, isAs400Down)
                  ? scrollToTableSchedaProdotto()
                  : service_gift
                    ? router.push(`/myaccount/accedi?next=${router.asPath}`)
                    : setPopupLogin(true)
              }
            />
            <Button
              label={t('Visualizza dettagli prodotto')}
              variant="ghost"
              icon={<Info />}
              icon_pos={'left'}
              onClick={() =>
                showDettagliProdotto(utente, service_gift, isAs400Down)
                  ? scrollToDettagli()
                  : service_gift
                    ? router.push(`/myaccount/accedi?next=${router.asPath}`)
                    : setPopupLogin(true)
              }
            />
          </div>

          {showRiepilogo(utente, service_gift, isAs400Down) && (
            <div className="main-prodotto__bottom">
              <LinkUtili
                service_gift={service_gift}
                wishlist={wishlist}
                handleWishlist={ArrowClick}
                articolo={selectedArticolo}
                prodotto={prodotto}
              />
            </div>
          )}

          <div className="prodotto__dettagli">
            <div className="prodotto__dettagli__colors">
              <p className="prodotto__dettagli__title">
                <Trans chiave="Colore" />:{' '}
                <span className="prodotto__dettagli__title-value">{selectedColor?.nome}</span>
              </p>
              <div className="prodotto__dettagli__wrapper prodotto__dettagli__wrapper--colors prodotto__dettagli__wrapper--colors--mobile">
                {prodotto.colori && filteredColori?.length > 0
                  ? filteredColori?.map((colore_filtrato) => (
                    <Color
                      isActive={colore_filtrato.id === selectedColor.id ? true : false}
                      onClick={() => {
                        handleChangeColor(
                          prodotto,
                          colore_filtrato,
                          selectedArticolo,
                          selectedTaglia
                        )
                      }}
                      img={colore_filtrato?.image}
                      key={colore_filtrato.nome}
                      color={colore_filtrato.nome}
                      selectable={colore_filtrato.id != selectedColor.id}
                      size={'md'}
                      sizeMobile={'lg'}
                      colorName={colore_filtrato?.codice + ' - ' + colore_filtrato?.nome}
                    />
                  ))
                  : prodotto.colori.map((colore, index) => (
                    <Color
                      isActive={colore.id === selectedColor.id ? true : false}
                      onClick={() => {
                        handleChangeColor(prodotto, colore, selectedArticolo, selectedTaglia)
                      }}
                      img={colore?.image}
                      key={index}
                      color={colore.nome}
                      selectable={colore.id != selectedColor.id}
                      size={'md'}
                      sizeMobile={'lg'}
                      colorName={colore?.codice + ' - ' + colore?.nome}
                    />
                  ))}
              </div>
            </div>

            {prodotto?.taglie && prodotto?.taglie?.length > 0 && (
              <>
                <div className="prodotto__dettagli__taglie">
                  <p className="prodotto__dettagli__title">
                    <Trans chiave="Taglia" />:{' '}
                    <span className="prodotto__dettagli__title-value">{selectedTaglia?.nome}</span>
                  </p>
                </div>
                <div className="prodotto__dettagli__taglie">
                  <div className="prodotto__dettagli__wrapper prodotto__dettagli__wrapper--taglie">
                    <p className="prodotto__dettagli__title">
                      <Trans chiave="Disponibili" />:
                    </p>
                    {filteredTaglie?.map((taglia, i) => (
                      <Taglia
                        key={i}
                        taglia={taglia.nome}
                        onClick={() => HandleChangeTaglia(taglia)}
                        isActive={selectedTaglia?.id === taglia.id ? true : false}
                        last={i === filteredTaglie.length - 1}
                      />
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="prodotto__dettagli__wrapper prodotto__dettagli__wrapper--colors">
            {prodotto.colori && filteredColori?.length > 0
              ? filteredColori?.map((colore_filtrato) => (
                <Color
                  isActive={colore_filtrato.id === selectedColor.id ? true : false}
                  onClick={() => {
                    handleChangeColor(prodotto, colore_filtrato, selectedArticolo, selectedTaglia)
                  }}
                  img={colore_filtrato?.image}
                  key={colore_filtrato.nome}
                  color={colore_filtrato.nome}
                  selectable={colore_filtrato.id != selectedColor.id}
                  size={'md'}
                  sizeMobile={'lg'}
                  colorName={colore_filtrato?.codice + ' - ' + colore_filtrato?.nome}
                />
              ))
              : prodotto.colori.map((colore, index) => (
                <Color
                  isActive={colore.id === selectedColor.id ? true : false}
                  onClick={() => {
                    handleChangeColor(prodotto, colore, selectedArticolo, selectedTaglia)
                  }}
                  img={colore?.image}
                  key={index}
                  color={colore.nome}
                  selectable={colore.id != selectedColor.id}
                  size={'md'}
                  sizeMobile={'lg'}
                  colorName={colore?.codice + ' - ' + colore?.nome}
                />
              ))}
          </div>

          <div style={{ position: 'absolute' }}>
            <ModalLogin visible={popupLogin} onClose={() => setPopupLogin(false)} />
          </div>

          <PrezziProdottoTable
            prodotto={prodotto}
            selectedArticolo={selectedArticolo}
            personalizzazioni={personalizzazioni}
            prezziPersonalizzazioni={prezziPersonalizzazioni}
          />

          <ConsegnaPrevista prodotto={prodotto} leadTimeSelected={leadTimeSelected} />
        </div>

      </div>
    </>
  )
}

export default React.memo(MainProdotto)

const LinkUtili = ({
  service_gift,
  wishlist,
  handleWishlist,
  articolo,
  prodotto,
  mail_campioni,
}) => {
  const t = useTrans()
  const { utente } = useSelector((state) => state.utente)
  const [linkUtiliMobileOpen, setLinkUtiliMobileOpen] = useState(false)
  const [richiediCampioneModalOpen, setRichiediCampioneModalOpen] = useState(false)
  const [scaricaInfoOpen, setScaricaInfoOpen] = useState(false)
  const { downloading, saveFile } = useDownloadFromApi()

  return (
    <>
      {articolo && (
        <div
          className={'link-utili' + (linkUtiliMobileOpen ? ' link-utili--mobile-open' : '')}
          onMouseLeave={() => setScaricaInfoOpen(false)}
        >
          <div className="link-utili__content">
            {(!service_gift?.attivo || true) && (
              <>
                <div
                  className="link-utili__item link-utili__item--download"
                  onClick={() => setScaricaInfoOpen(!scaricaInfoOpen)}
                >
                  <span className="link-utili__icon">
                    <Download />
                  </span>
                  {t('Scarica o invia info prodotto')}
                  <div
                    className={'download-menu' + (scaricaInfoOpen ? ' download-menu--open' : '')}
                  >
                    <ul className="download-menu__list">
                      {!service_gift && (
                        <li className="download-menu__item">
                          <div className="download-menu__inner-item">
                            {t('Scarica immagini prodotto')}
                            <span className="download-menu__arrow">
                              <ChevronRight />
                            </span>
                          </div>
                          <ul className="download-menu__submenu">
                            <li className="download-menu__item">
                              <div className="download-menu__inner-item">
                                <a
                                  href={articolo?.url_zip_immagini_altarisoluzione}
                                  onClick={(e) => {
                                    e.preventDefault()
                                    if (downloading) return
                                    trackingDownload('immagini', `${articolo?.codice}_images_hq`)
                                    saveFile(
                                      'hq',
                                      articolo?.url_zip_immagini_altarisoluzione,
                                      `${articolo?.codice}_images_hq.zip`
                                    )
                                  }}
                                  disabled={downloading}
                                >
                                  {t('Scarica immagini ad alta risoluzione')}
                                </a>
                              </div>
                            </li>
                            <li className="download-menu__item">
                              <div className="download-menu__inner-item">
                                <a
                                  href={articolo?.url_zip_immagini}
                                  onClick={(e) => {
                                    e.preventDefault()
                                    if (downloading) return
                                    trackingDownload('immagini', `${articolo?.codice}_images_lq`)
                                    saveFile(
                                      'lq',
                                      articolo?.url_zip_immagini,
                                      `${articolo?.codice}_images_lq.zip`
                                    )
                                  }}
                                  disabled={downloading}
                                >
                                  {t('Scarica immagini a bassa risoluzione')}
                                </a>
                              </div>
                            </li>
                          </ul>
                        </li>
                      )}
                      <li className="download-menu__item">
                        <div className="download-menu__inner-item">
                          {t('Scarica o invia scheda prodotto')}
                          <span className="download-menu__arrow">
                            <ChevronRight />
                          </span>
                        </div>
                        <ul className="download-menu__submenu">
                          <li className="download-menu__item">
                            <div className="download-menu__inner-item">
                              <Mailto
                                email=""
                                subject={t('Scheda tecnica prodotto') + ' ' + articolo?.codice}
                                body={
                                  t('Scarica la scheda tecnica del prodotto') +
                                  ' ' +
                                  `${articolo?.codice} ${articolo?.url_scheda_tecnica}`
                                }
                              >
                                {t('Invia scheda prodotto via e-mail')}
                              </Mailto>
                            </div>
                          </li>
                          <li className="download-menu__item">
                            <div className="download-menu__inner-item">
                              <a
                                href={`${articolo?.url_scheda_tecnica}`}
                                onClick={(e) => {
                                  e.preventDefault()
                                  if (downloading) return
                                  saveFile(
                                    'scheda-tecnica',
                                    `${articolo?.url_scheda_tecnica}`,
                                    `${service_gift?.nome || 'sipec'}-prodotto-${prodotto?.codice
                                    }-${articolo?.slug}.pdf`
                                  )
                                }}
                                disabled={downloading}
                              >
                                {t('Scarica scheda prodotto in pdf')}
                              </a>
                            </div>
                          </li>
                        </ul>
                      </li>

                      {articolo?.documenti?.map((doc, index) => (
                        <li key={index} className="download-menu__item">
                          <div className="download-menu__inner-item">
                            <a
                              href={doc.url}
                              download
                              target="_blank"
                            >
                              {t("Scarica")} {doc.nome}
                            </a>
                          </div>
                        </li>
                      ))}


                    </ul>
                  </div>
                </div>

                {!service_gift && (
                  <div
                    className="link-utili__item"
                    onClick={() => setRichiediCampioneModalOpen(true)}
                  >
                    <span className="link-utili__icon">
                      <EMail />
                    </span>
                    <Mailto
                      email={mail_campioni}
                      subject={t('Richiesta campioni')}
                      body={t('Richiesta campioni prodotto') + ' ' + articolo.codice}
                    >
                      {t('Richiedi campione')}
                    </Mailto>
                  </div>
                )}

                {!service_gift?.attivo && articolo?.catalogo_instance !== null && (
                  <div className="link-utili__item link-utili__item__catalogo">
                    <span className="link-utili__icon">
                      <Book />
                    </span>
                    <p>
                      <Trans chiave="Pagina" /> {articolo?.pagina_catalogo}{' '}
                      {articolo?.catalogo_instance?.titolo &&
                        articolo?.catalogo_instance?.titolo.toLowerCase().includes(t('catalogo')) ? (
                        <>{articolo?.catalogo_instance?.titolo}</>
                      ) : (
                        <>
                          <Trans chiave="Catalogo" /> {articolo?.catalogo_instance?.titolo}
                        </>
                      )}
                    </p>
                  </div>
                )}

                {utente && (
                  <div className="link-utili__item" onClick={handleWishlist}>
                    <span className="link-utili__icon">
                      {wishlist ? <WishlistFill /> : <WishlistLine />}
                    </span>
                    {wishlist ? t('Rimuovi dai preferiti') : t('Aggiungi ai preferiti')}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </>
  )
}

const Mailto = ({ email = '', subject = '', body = '', children }) => {
  let params = subject || body ? '?' : ''
  if (subject) params += `subject=${encodeURIComponent(subject)}`
  if (body) params += `${subject ? '&' : ''}body=${encodeURIComponent(body)}`

  return <a href={`mailto:${email}${params}`}>{children}</a>
}

const ConsegnaPrevista = ({ prodotto, leadTimeSelected }) => {
  const t = useTrans()
  const { locale } = useRouter()
  const { utente } = useSelector((state) => state.utente)
  const { service_gift } = useSelector((state) => state.servicegift)
  const [consegna, setConsegna] = useState()

  useEffect(() => {
    showButtonsRiepilogo(utente, service_gift) &&
      prodotto &&
      api
        .get(`${GIORNICONSEGNA}${prodotto.codice}/`, { params: { lang: locale } })
        .then((response) => setConsegna(response.data))
  }, [utente])

  return consegna ? (
    <div className="consegna-prevista">
      {consegna.entro_ore !== null && (
        <div className="consegna-prevista__block">
          <div className="consegna-prevista__content">
            <div className="consegna-prevista__title">
              <span className="consegna-prevista__icon">
                <Car />
              </span>
              <span>
                <strong>
                  {consegna.entro_ore > 0
                    ? t('Partenza prevista se ordini entro {0} ore:', [consegna.entro_ore])
                    : t('Partenza prevista se ordini entro {0} minuti:', [consegna.entro_minuti])}
                </strong>
              </span>
            </div>
            <ul>
              <li>
                <strong>
                  <Trans chiave="Merce neutra" />:
                </strong>{' '}
                {consegna.neutra_dal}
              </li>
              <li>
                <strong>
                  <Trans chiave="Merce personalizzata" />:
                </strong>{' '}
                {(!service_gift ? leadTimeSelected?.data_spedizione || consegna.personalizzata_dal_by_fornitore : null) || consegna.personalizzata_dal}
                <span className="consegna-prevista__info">
                  <Tooltip
                    label={t(
                      'Data di partenza della spedizione potrebbe variare in base alla data di approvazione della bozza digitale o del campione fisico'
                    )}
                  >
                    <Info />
                  </Tooltip>
                </span>
              </li>
            </ul>
          </div>
        </div>
      )}
      {consegna.indirizzo !== null && (
        <div className="consegna-prevista__block">
          
          <div className="consegna-prevista__content">
            <div className="consegna-prevista__title">
              <span className="consegna-prevista__icon">
                <Pin />
              </span>
              <span>
                <strong>{t("Invia a")}:</strong>
              </span>
              </div>
            <p>{consegna.indirizzo}</p>
          </div>
        </div>
      )}
    </div>
  ) : null
}
